import gql from 'graphql-tag';

export const GET_CARD_EVENTS = gql`
  fragment transactionEvents on EventsByType {
    CLEARED {
      day
      count
    }
    AUTHORIZED {
      day
      count
    }
    RETURNED {
      day
      count
    }
  }

  fragment eventRatios on EventRatio {
    CLEARED {
      count
    }

    AUTHORIZED {
      count
    }
    RETURNED {
      count
    }
  }

  query getCardEvents($params: CardNetworkInput!) {
    cnTransactionEventRatioByMarketplace(params: $params) {
      DOSH {
        VISA {
          ...eventRatios
        }

        MASTERCARD {
          ...eventRatios
        }

        AMEX {
          ...eventRatios
        }
      }
    }

    cnTransactionEventsByMarketplaceByType(params: $params) {
      DOSH {
        VISA {
          ...transactionEvents
        }

        MASTERCARD {
          ...transactionEvents
        }

        AMEX {
          ...transactionEvents
        }
      }
    }
  }
`;

export default GET_CARD_EVENTS;
